export default "__VITE_ASSET__CuJEokqw__"